import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchEquiposByFederacion as fetchEquiposAPI,
         createTeam as createTeamAPI,
         deleteTeam,
         updateTeam as updateTeamAPI 
         } from '../../services/equipoService';

const initialState = {
  teams: [], 
  loading: false,
  error: null,
};

export const fetchEquipos = createAsyncThunk(
  'equipos/fetchEquipos',
  async (federacionId, { rejectWithValue }) => {
    try {
      const data = await fetchEquiposAPI(federacionId);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al obtener equipos');
    }
  }
);

export const createTeam = createAsyncThunk(
  'equipos/createTeam',
  async (newTeam, { rejectWithValue }) => {
    try {
      const data = await createTeamAPI(newTeam);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al crear el equipo');
    }
  }
);

export const removeTeam = createAsyncThunk(
  'equipos/removeTeam',
  async (idTeam, { rejectWithValue }) => {
    try {
      const response = await deleteTeam(idTeam);
      return idTeam;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al eliminar el equipo');
    }
  }
);

export const updateTeam = createAsyncThunk(
  'equipos/updateTeam',
  async ({ idTeam, data }, { rejectWithValue }) => {
    try {
      const response = await updateTeamAPI(idTeam, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error al modificar el equipo');
    }
  }
);

const equiposSlice = createSlice({
  name: 'equipos',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEquipos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEquipos.fulfilled, (state, action) => {
        state.loading = false;
        state.teams = action.payload;
      })
      .addCase(fetchEquipos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTeam.fulfilled, (state, action) => {
        state.teams.push(action.payload);
      })
      .addCase(createTeam.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateTeam.fulfilled, (state, action) => {
        const index = state.teams.findIndex((team) => team.id_equipo === action.payload.id_equipo);
        if (index !== -1) {
          state.teams[index] = action.payload;
        }
      })
  },
});

// Selector para obtener el número de equipos disponibles en la federación
export const selectTeamCount = (state) => state.equipos.teams.length;

export default equiposSlice.reducer;
